<template>
  <div>
    <!-- ===== لیست پست‌ها ===== -->
    <template v-if="!activeSlug">
      <v-slide-group v-if="categories.length > 0" class="mb-4" show-arrows center-active>
        <v-slide-group-item>
          <v-chip
            class="ma-1"
            :color="!activeCategory ? 'primary' : 'surface-variant'"
            :variant="!activeCategory ? 'flat' : 'outlined'"
            rounded="xl"
            @click="selectCategory(null)"
          >همه</v-chip>
        </v-slide-group-item>
        <v-slide-group-item v-for="cat in categories" :key="cat.id">
          <v-chip
            class="ma-1"
            :color="activeCategory === cat.slug ? 'primary' : 'surface-variant'"
            :variant="activeCategory === cat.slug ? 'flat' : 'outlined'"
            rounded="xl"
            @click="selectCategory(cat.slug)"
          >{{ cat.title }}</v-chip>
        </v-slide-group-item>
      </v-slide-group>

      <div v-if="loading" class="d-flex justify-center py-10">
        <v-progress-circular indeterminate color="primary" />
      </div>

      <div v-else-if="posts.length === 0" class="text-center py-10 text-medium-emphasis">
        مطلبی برای نمایش وجود ندارد.
      </div>

      <v-row v-else dense>
        <v-col cols="12" sm="6" v-for="post in posts" :key="post.id">
          <v-card rounded="xl" elevation="0" border class="overflow-hidden" style="cursor:pointer" @click="openPost(post.slug)">
            <v-img v-if="post.cover_image" :src="$store.state.fileBaseUrl + post.cover_image" height="160" cover />
            <div class="pa-3">
              <div class="text-subtitle-1 font-weight-bold mb-1">{{ post.title }}</div>
              <div v-if="post.excerpt" class="text-body-2 text-medium-emphasis text-truncate-2">{{ post.excerpt }}</div>
              <div v-if="post.date_created" class="text-caption text-medium-emphasis mt-2">{{ toJalali(post.date_created) }}</div>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <div v-if="lastPage > 1" class="d-flex justify-center mt-6">
        <v-pagination v-model="page" :length="lastPage" density="comfortable" @update:model-value="changePage" />
      </div>
    </template>

    <!-- ===== جزئیات پست ===== -->
    <template v-else>
      <v-btn variant="text" prepend-icon="mdi-arrow-right" class="mb-3" @click="goToList">
        بازگشت به لیست
      </v-btn>

      <div v-if="postLoading" class="d-flex justify-center py-10">
        <v-progress-circular indeterminate color="primary" />
      </div>

      <template v-else-if="post">
        <v-img
          v-if="post.cover_image"
          :src="$store.state.fileBaseUrl + post.cover_image"
          height="220"
          cover
          rounded="xl"
          class="mb-4"
        />

        <div class="blog-article-card">
          <v-chip v-if="postCategory" size="small" color="primary" variant="tonal" class="mb-3">{{ postCategory.title }}</v-chip>
          <h1 class="blog-article-title">{{ post.title }}</h1>
          <div class="blog-content" v-html="contentHtml"></div>
        </div>

        <v-divider v-if="related.length > 0" class="my-6" />

        <template v-if="related.length > 0">
          <div class="text-subtitle-1 font-weight-bold mb-3">مطالب مرتبط</div>
          <v-row dense>
            <v-col cols="6" v-for="r in related" :key="r.id">
              <v-card rounded="xl" elevation="0" border style="cursor:pointer" @click="openPost(r.slug)">
                <div class="pa-3 text-body-2 font-weight-bold">{{ r.title }}</div>
              </v-card>
            </v-col>
          </v-row>
        </template>
      </template>

      <div v-else class="text-center py-10 text-medium-emphasis">
        این مطلب پیدا نشد.
      </div>
    </template>
  </div>
</template>

<script>
import { toJalali } from '@/utils/jalali';

export default {
  name: 'BlogPanel',
  data: () => ({
    page: 1,
    activeCategory: null,
    activeSlug: null,
  }),
  computed: {
    posts()        { return this.$store.state.blog.posts; },
    categories()   { return this.$store.state.blog.categories; },
    loading()      { return this.$store.state.blog.loading; },
    lastPage()     { return this.$store.state.blog.lastPage; },
    postLoading()  { return this.$store.state.blogPost.loading; },
    post()         { return this.$store.state.blogPost.post; },
    postCategory() { return this.$store.state.blogPost.category; },
    related()      { return this.$store.state.blogPost.related; },
    contentHtml() {
      const raw = this.post?.content || '';
      if (/<[a-z][\s\S]*>/i.test(raw)) return raw;
      return raw.replaceAll('\n', '<br/>');
    },
  },
  mounted() {
    this.fetchList();
  },
  methods: {
    fetchList() {
      this.$store.dispatch('fetchBlogList', { category: this.activeCategory, page: this.page });
    },
    selectCategory(slug) {
      this.activeCategory = slug;
      this.page = 1;
      this.fetchList();
    },
    changePage(p) {
      this.page = p;
      this.fetchList();
    },
    openPost(slug) {
      this.activeSlug = slug;
      this.$store.dispatch('fetchBlogPost', slug);
    },
    goToList() {
      this.activeSlug = null;
    },
    toJalali,
  },
};
</script>

<style scoped>
.text-truncate-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.blog-article-card {
  position: relative;
  border-radius: 24px;
  padding: 20px 18px 26px;
  margin-bottom: 8px;
  background: linear-gradient(180deg, rgba(var(--v-theme-primary), 0.07), rgba(var(--v-theme-surface), 0.6));
  border: 1px solid rgba(var(--v-theme-primary), 0.14);
  backdrop-filter: blur(16px) saturate(140%);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.blog-article-title {
  font-size: 1.32rem;
  font-weight: 800;
  line-height: 1.7;
  margin-bottom: 16px;
  color: rgb(var(--v-theme-on-surface));
}

.blog-content {
  color: rgba(var(--v-theme-on-surface), 0.85);
  font-size: 0.95rem;
  line-height: 2.1;
}

.blog-content :deep(h1),
.blog-content :deep(h2),
.blog-content :deep(h3),
.blog-content :deep(h4) {
  font-weight: 800;
  color: rgb(var(--v-theme-on-surface));
  margin: 28px 0 12px;
  line-height: 1.8;
  position: relative;
  padding-inline-start: 14px;
}
.blog-content :deep(h1):first-child,
.blog-content :deep(h2):first-child,
.blog-content :deep(h3):first-child {
  margin-top: 4px;
}
.blog-content :deep(h1)::before,
.blog-content :deep(h2)::before,
.blog-content :deep(h3)::before {
  content: '';
  position: absolute;
  right: 0;
  top: 5px;
  bottom: 5px;
  width: 4px;
  border-radius: 4px;
  background: rgb(var(--v-theme-primary));
}
.blog-content :deep(h1) { font-size: 1.28rem; }
.blog-content :deep(h2) { font-size: 1.16rem; }
.blog-content :deep(h3) { font-size: 1.04rem; }
.blog-content :deep(h4) { font-size: 0.98rem; }

.blog-content :deep(p) { margin: 0 0 16px; }
.blog-content :deep(a) {
  color: rgb(var(--v-theme-primary));
  text-decoration: underline;
  text-underline-offset: 3px;
}
.blog-content :deep(strong),
.blog-content :deep(b) {
  font-weight: 800;
  color: rgb(var(--v-theme-on-surface));
}
.blog-content :deep(ul),
.blog-content :deep(ol) {
  margin: 0 0 16px;
  padding-inline-start: 22px;
}
.blog-content :deep(li) { margin-bottom: 8px; }
.blog-content :deep(blockquote) {
  margin: 18px 0;
  padding: 10px 16px;
  border-inline-end: 3px solid rgb(var(--v-theme-primary));
  background: rgba(var(--v-theme-primary), 0.07);
  border-radius: 8px;
  color: rgba(var(--v-theme-on-surface), 0.75);
}
.blog-content :deep(img) {
  max-width: 100%;
  border-radius: 14px;
  margin: 14px 0;
  display: block;
}
.blog-content :deep(hr) {
  border: none;
  border-top: 1px solid rgba(var(--v-theme-on-surface), 0.12);
  margin: 22px 0;
}
</style>
